import { type FC } from "react";

import { t } from "i18n/i18n";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { CourseWithGroupingType } from "store/selectors/types";

type MoveCoursesConfirmationModalProps = {
  courses: Pick<CourseWithGroupingType, "id" | "code" | "groupingTitle">[];
  onConfirm: () => void;
  onCancel: () => void;
};

export const MoveCoursesConfirmationModal: FC<MoveCoursesConfirmationModalProps> = ({
  courses,
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="flex flex-col">
      <div className="flex flex-col gap-4">
        <div>{t("home.courses.move_courses_confirmation_label")}</div>

        <div className="flex flex-col gap-2 border-l-2 border-score-1">
          {courses.map((course) => (
            <div className="pl-4" key={course.id}>
              {course.code} {" - "}
              {course.groupingTitle}
            </div>
          ))}
        </div>

        <div>{t("home.courses.move_courses_confirmation_question")}</div>
      </div>

      <div className="mt-8 flex w-full justify-end gap-2">
        <SquareButton kind="tertiary" size="m" title={t("common.cancel")} onClick={onCancel}>
          {t("common.cancel")}
        </SquareButton>

        <SquareButton
          kind="caution"
          size="m"
          title={t("home.courses.move_courses_title")}
          onClick={onConfirm}
        >
          {t("home.courses.move_courses_title")}
        </SquareButton>
      </div>
    </div>
  );
};
